(() => {
  const mount = document.querySelector("[data-vsc-page-mount]");
  if (!mount) return;
  let timeout;
  let failed = false;
  const fallback = () => {
    failed = true;
    window.clearTimeout(timeout);
    delete document.documentElement.dataset.vscPageReady;
    document.documentElement.dataset.vscPageDisabled = "true";
    document.querySelector("[data-vsc-page-loader]")?.remove();
    mount.hidden = true;
  };
  const bootstrap = document.querySelector(
    "[data-vivazz-smart-cart-bootstrap]",
  );
  let enabled = false;
  let previewRequested = false;
  try {
    enabled = JSON.parse(bootstrap?.dataset.config || "null")?.enabled === true;
    previewRequested =
      Boolean(bootstrap) &&
      (new URLSearchParams(location.search).has("vsc_preview") ||
        Boolean(sessionStorage.getItem("vivazz-cart-preview")));
  } catch {
    /* A missing or invalid embed keeps the theme cart available. */
  }
  if (!enabled && !previewRequested) {
    fallback();
    return;
  }
  window.addEventListener("vivazz:fallback", fallback, { once: true });
  timeout = window.setTimeout(fallback, 20000);
  const adapt = (host) => {
    if (!host || !host.active || !host.shadowRoot) return;
    if (typeof host.dialog?.show !== "function") {
      fallback();
      return;
    }
    if (host.parentElement !== mount) {
      const destroy = host.destroy;
      host.destroy = () => {};
      try {
        mount.append(host);
      } finally {
        host.destroy = destroy;
      }
    }
    if (host.dataset.pageAdapted === "true") return;
    host.dataset.pageAdapted = "true";
    const style = document.createElement("style");
    style.textContent = `
      :host { display:block; }
      .drawer[open] { position:relative!important; inset:auto!important; margin:0!important; width:100%!important; max-width:none!important; height:auto!important; max-height:none!important; transform:none!important; border:0!important; box-shadow:none!important; border-radius:0!important; overflow:visible!important; }
      .header { padding:20px 0!important; grid-column:1 / -1; }
      .title { font-size:26px!important; }
      .close { display:none!important; }
      .view-cart { display:none!important; }
      .scroll-area { overflow:visible!important; height:auto!important; max-height:none!important; flex:none!important; }
      .content { padding:20px 0!important; outline:none!important; }
      .item { padding:16px 0!important; }
      .media { width:100px!important; height:100px!important; flex:0 0 100px!important; }
      .media img { width:100%!important; height:100%!important; object-fit:contain!important; }
      .item-title { font-size:15px!important; }
      .footer { position:static!important; padding:24px 0!important; border-top:1px solid var(--vsc-border)!important; }
      @media(min-width:750px) {
        .drawer[open] { display:block!important; }
        .vsc-cart-main { display:grid; grid-template-columns:minmax(0,2fr) minmax(300px,1fr); column-gap:40px; align-items:start; }
        .vsc-cart-main .scroll-area { grid-row:1; }
        .vsc-cart-main .footer { grid-row:1; }
        .scroll-area { grid-column:1; grid-row:2; min-width:0; }
        .footer { grid-column:2; grid-row:2; position:sticky!important; top:calc(var(--header-height, 90px) + 24px)!important; align-self:start; border:1px solid var(--vsc-border)!important; border-radius:12px!important; padding:24px!important; max-height:calc(100dvh - 140px); overflow:auto; }
        .footer::before { content:"Resumo"; display:block; font-size:22px; font-weight:700; margin-bottom:20px; }
        .upsell { grid-column:1 / -1; grid-row:3; min-width:0; }
        .checkout { width:100%;max-width:none; }
      }
      .footer[hidden] { display:none!important; }
      .checkout { max-width:480px; margin-left:auto; }
      .upsell { margin:24px 0 0!important; padding:24px 16px!important; }
      .upsell-list { display:grid!important; grid-template-columns:repeat(4,minmax(0,1fr))!important; overflow:visible!important; }
      .upsell-card { width:auto!important; min-width:0!important; }
      .upsell-card:nth-child(n + 11) { display:none!important; }
      .upsell-arrow { display:none!important; }
      @media(max-width:749px) { .title {font-size:22px!important;} .media {width:76px!important;height:76px!important;flex-basis:76px!important;} .upsell {padding:16px 8px!important;} .upsell-list {grid-template-columns:repeat(2,minmax(0,1fr))!important;} .checkout {max-width:none;} }

      @media(max-width:749px) {
        :host { padding-bottom:calc(var(--vsc-mobile-footer-height, 220px) + 16px); }
        .footer { position:fixed!important; inset:auto 0 0!important; width:100%!important; box-sizing:border-box!important; margin:0!important; padding:16px 12px calc(16px + env(safe-area-inset-bottom, 0px))!important; background:#fff!important; z-index:1000!important; box-shadow:0 -4px 16px rgb(0 0 0 / 8%); max-height:70dvh; overflow:auto; }
        .checkout { width:100%!important; }
      }
    `;
    host.shadowRoot.append(style);
    host.closeButton.hidden = true;
    host.dialog.setAttribute("role", "region");
    host.dialog.removeAttribute("aria-modal");
    if (host.dialog.open) host.dialog.close();
    if (document.documentElement.style.overflow === "hidden")
      document.documentElement.style.overflow = host.previousOverflow || "";
    host.show = () => {
      if (!host.dialog.open) host.dialog.show();
    };
    host.close = () => {};
    const cartMain = document.createElement("div");
    cartMain.className = "vsc-cart-main";
    const scrollArea = host.shadowRoot.querySelector(".scroll-area");
    const footer = host.shadowRoot.querySelector(".footer");
    host.dialog.insertBefore(cartMain, scrollArea);
    cartMain.append(scrollArea, footer);
    const setCart = host.setCart.bind(host);
    host.setCart = (cart) => {
      setCart(cart);
      host.dialog.append(host.upsellSection);
    };
    host.dialog.append(host.upsellSection);
    host.show();
    const mobileFooter = host.shadowRoot.querySelector(".footer");
    if (mobileFooter) {
      const syncFooterHeight = () => {
        host.style.setProperty(
          "--vsc-mobile-footer-height",
          mobileFooter.getBoundingClientRect().height + "px",
        );
      };
      const footerObserver = new ResizeObserver(syncFooterHeight);
      footerObserver.observe(mobileFooter);
      syncFooterHeight();
    }
    window.clearTimeout(timeout);
    requestAnimationFrame(() => {
      if (failed) return;
      delete document.documentElement.dataset.vscPageDisabled;
      document.documentElement.dataset.vscPageReady = "true";
      document.querySelector("[data-vsc-page-loader]")?.remove();
    });
  };
  const safelyAdapt = (host) => {
    if (failed) {
      host?.api?.destroy?.();
      return;
    }
    try {
      adapt(host);
    } catch {
      host?.api?.destroy?.();
      fallback();
    }
  };
  document.addEventListener("vivazz:ready", (event) =>
    safelyAdapt(event.target),
  );
  safelyAdapt(document.querySelector("vivazz-smart-cart"));
})();
